import React from 'react';
import TimeUtil from 'time';
import TimeConstants from 'shared/constants/Time';

/**
 * ReadOnly Clock component
 */
export default React.createClass({
  displayName: 'Clock',

  propTypes: {
    date: React.PropTypes.number.isRequired,
    twentyFourHour: React.PropTypes.bool,
    timeZone: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      twentyFourHour: false,
      timeZone: TimeConstants.DefaultTimeZone,
    };
  },

  render() {
    let { date, twentyFourHour, timeZone } = this.props;

    return (
      <div className="clock">
        {TimeUtil.getFormattedTimeWithSeconds(date, twentyFourHour, timeZone)}
      </div>
    );
  },
});
